import { useIssueResolver } from 'hooks/useIssueResolver';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { PartnerDTO, MessageV2DTO, SenderEnvelopeDTO, IssueResolverType } from 'support/types';

type useIssueResolverNameProps = {
  currentPartner: PartnerDTO | undefined;
  partner: PartnerDTO | undefined | null;
} & (
  | {
      document: MessageV2DTO;
      isMessage: true;
    }
  | {
      document: SenderEnvelopeDTO | undefined;
      isMessage: false;
    }
);

export const useIssueResolverName = ({ document, isMessage, currentPartner, partner }: useIssueResolverNameProps) => {
  const { t } = useTranslation();
  const hasBlockingError = isMessage ? document.blocking_error : document?.blockingError;
  const issueResolver = useIssueResolver(isMessage ? document.issue_resolver_id : document?.issueResolverId);

  const issueResolverPartnerName = useMemo(() => {
    switch (issueResolver) {
      case IssueResolverType.PROCUROS:
        return t('common:procuros');
      case IssueResolverType.CURRENT_PARTNER:
        return currentPartner?.name || '';
      default:
        return partner?.name || '';
    }
  }, [issueResolver, currentPartner?.name, partner?.name, t]);

  return hasBlockingError ? issueResolverPartnerName : undefined;
};
